<div mat-dialog-title>
  <h2>
    {{data.title}}
  </h2>
  <button type="button" class="close" mat-dialog-close aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">
    <form [formGroup]="formGroup">
      <ng-container *ngIf="data && data.helpersTop && data.helpersTop.length">
        <p [class]="item.class" *ngFor="let item of data.helpersTop" [innerHTML]="item.label">
        </p>
      </ng-container>

      <div class="fields-group" *ngIf="fields.length">
        <ng-container *ngFor="let field of fields; index as i">
          <ng-container *ngIf="field.inputTypeId === 7">
            <h4 class="label-form" *ngIf="field.inputTitle">{{field.inputTitle}}</h4>
            <div class="form-group">
              <div class="radio-selector">
                <mat-radio-group [formControlName]="field.id" class="row">
                  <mat-radio-button *ngFor="let item of field.values" class="col-6"
                    [ngClass]="{'col-12':field.values.length == 1}" [value]="item.id">
                    {{item.title}}
                  </mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="hasError('required',field.id) && isSubmitted">
                  {{ 'forms.Required' | translate}}
                </mat-error>
                <mat-hint *ngIf="field.validationMessage">{{field.validationMessage}}</mat-hint>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="data && data.helpersMiddle && data.helpersMiddle.length && i == 0">
            <p [class]="item.class" *ngFor="let item of data.helpersMiddle" [innerHTML]="item.label">
            </p>
          </ng-container>

          <mat-form-field class="form-group" *ngIf="field.inputTypeId == 3">
            <mat-label>{{field.inputTitle}}</mat-label>
            <input matInput [formControlName]="field.id" appOnlynumber [maxlength]="field.fieldLength">
            <mat-error *ngIf="hasError('required',field.id)">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError('pattern',field.id)">{{ 'forms.Invalid number' | translate }}</mat-error>
            <mat-error *ngIf="hasError('min',field.id)">
              <!-- Minimum is {{field.jsonProps.minimumRange}} Characters -->
              {{ 'forms.minimumIsCharacters' | translate:{num:field.jsonProps.minimumRange} }}
            </mat-error>
            <mat-error *ngIf="hasError('max',field.id)">
              <!-- Maximum is {{field.jsonProps.maxRange}} Characters -->
              {{ 'forms.maxLengthIsCharacters' | translate:{num:field.jsonProps.maxRange} }}

            </mat-error>
            <mat-error *ngIf="hasError('maxLength',field.id)">
              <!-- Max Length is {{field.fieldLength}} Number -->
              {{ 'forms.maxLengthIsNumber' | translate:{num:field.fieldLength} }}

            </mat-error>
            <mat-hint *ngIf="field.validationMessage">{{field.validationMessage}}</mat-hint>
          </mat-form-field>

          <mat-form-field class="form-group mb-0" *ngIf="field.inputTypeId == 5">
            <mat-label>{{field.inputTitle}}</mat-label>
            <input matInput [formControlName]="field.id" [maxlength]="field.fieldLength">
            <mat-error *ngIf="hasError('required',field.id)">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError('pattern',field.id)">{{ 'forms.Invalid number' | translate }}</mat-error>
            <mat-error *ngIf="hasError('min',field.id)">
              <!-- Minimum is {{field.jsonProps.minimumRange}} Characters -->
              {{ 'forms.minimumIsCharacters' | translate:{num:field.jsonProps.minimumRange} }}
            </mat-error>
            <mat-error *ngIf="hasError('max',field.id)">
              <!-- Maximum is {{field.jsonProps.maxRange}} Characters -->
              {{ 'forms.maxLengthIsCharacters' | translate:{num:field.jsonProps.maxRange} }}
            </mat-error>
            <mat-error *ngIf="hasError('maxLength',field.id)">
              <!-- Max Length is {{field.fieldLength}} Number -->
              {{ 'forms.maxLengthIsNumber' | translate:{num:field.fieldLength} }}

            </mat-error>
            <mat-error *ngIf="hasError('notUniqe',field.id)">
              {{field.id}} {{ 'forms.alreadyExist'|translate }}
            </mat-error>
            <mat-hint *ngIf="field.validationMessage">{{field.validationMessage}}</mat-hint>
          </mat-form-field>

          <mat-form-field class="form-group" *ngIf="field.inputTypeId == 6">
            <mat-label>{{field.inputTitle}}</mat-label>
            <textarea matInput [formControlName]="field.id" [maxlength]="field.fieldLength"></textarea>
            <mat-error *ngIf="hasError('required',field.id)">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError('maxLength',field.id)">
              <!-- Max Length is {{field.fieldLength}} Characters -->
              {{ 'forms.maxLengthIsCharacters' | translate:{num:field.fieldLength} }}
            </mat-error>
            <mat-hint *ngIf="field.validationMessage">{{field.validationMessage}}</mat-hint>
          </mat-form-field>
          <div class="mat-dialog-inner" *ngIf="field.inputTypeId == 9">
            <h3 class="subhead-form">
              {{field.inputTitle}} <span *ngIf="!field.isMandatory">(Optional)</span>
            </h3>
            <div class="fields-group">
              <app-file-manager [isRequired]="field.isMandatory" [managerIndex]="'attachements_'+field.id"
                [isSubmitted]="isSubmitted" [allowedExt]="field.allowedExt" [maxSize]="field.maxSize"
                [maxFiles]="field.maxFiles" [label]="'slideDetails.dragAndDropFilesHere'|translate"
                [files]="field.value" (selectedFiles)="field.value = $event"
                (deletedFilesList)="field.deletedAttachments = $event">
              </app-file-manager>
            </div>
          </div>
          <div class="form-group" *ngIf="field.inputTypeId == 10">
            <ngx-intl-tel-input [customPlaceholder]="''" [enableAutoCountrySelect]="true"
              [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [maxLength]="50"
              [numberFormat]="PhoneNumberFormat.International" [phoneValidation]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [searchCountryFlag]="true"
              [searchCountryFlag]="true" [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO"
              [separateDialCode]="true" [formControlName]="field.id" [attr.name]="field.id">
            </ngx-intl-tel-input>
            <p class="has-error" *ngIf="hasError('required',field.id) && isSubmitted">
              {{ 'forms.Required' | translate }}
            </p>

            <p class="has-error" *ngIf="hasError('validatePhoneNumber',field.id)">
              {{"labProfile.enterValidNumberAccordingSelectedCountry"|translate}}
            </p>
          </div>
          <mat-form-field class="form-group" *ngIf="field.inputTypeId == 11">
            <mat-label>{{field.inputTitle}}</mat-label>
            <input matInput [formControlName]="field.id" maxlength="50">
            <mat-error *ngIf="hasError('required',field.id)">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError('invalid',field.id)">{{ 'forms.Invalid-Email' | translate }}</mat-error>
            <mat-error *ngIf="hasError('pattern',field.id)">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          </mat-form-field>
        </ng-container>
      </div>

      <ng-container *ngIf="data && data.helpersbottom && data.helpersbottom.length">
        <p [class]="item.class" *ngFor="let item of data.helpersbottom" [innerHTML]="item.label"></p>
      </ng-container>

      <button class="w-100 {{data.btnSubmitClass}}" mat-raised-button color="primary" [disabled]="loading"
        [class.loading]='loading' (click)="saveRecord()">
        {{data.btnSubmitTitle}}
      </button>
      <button mat-raised-button mat-dialog-close color="grey" [class.loading]='loading' [disabled]="loading"
        class="w-100 mt-3" type="button" *ngIf="data.showClose">
        {{"swalMsg.cancel"|translate}}
      </button>
      <button mat-raised-button color="grey" [disabled]="loading" class="w-100 mt-3" type="button"
        (click)="backDialog()" *ngIf="data.showBack">
        {{"swalMsg.goBack"|translate}}
      </button>
    </form>
  </div>
</mat-dialog-content>